'use client';

import { Container } from '../Container';
import { ProfileCard, ProfileCardProps } from '../ProfileCard';
import { CSSProperties } from 'react';
import { TextSectionBlock, TextSectionBlockProps } from '../TextSectionBlock';
import { cn } from '../_lib/utils';

export type ProfileCardsProps = {
	className?: string;
	stickyTitle?: boolean;
	numberOfColumns?: number;
	textSectionBlock?: Omit<TextSectionBlockProps, 'size'>;
	profiles?: ProfileCardProps[];
};

export function ProfileCards(props: ProfileCardsProps) {
	const stickyTitle = props.stickyTitle ?? false;

	let smCols = 2;
	let lgCols = 3;

	if (props.numberOfColumns !== undefined) {
		if (props.numberOfColumns < smCols) {
			smCols = props.numberOfColumns;
		}

		lgCols = props.numberOfColumns;
	}

	return (
		<section className={props.className} data-component='ProfileCards'>
			<Container className={cn('flex flex-col gap-responsive-4xl', stickyTitle ? 'md:flex-row md:items-start' : '')}>
				<div className={cn('max-w-xl', stickyTitle ? 'md:flex-[0_0_30%] md:sticky md:top-[var(--header-offset,0)]' : '')}>
					{props.textSectionBlock && <TextSectionBlock size={stickyTitle ? 'md' : 'lg'} {...props.textSectionBlock} />}
				</div>

				{props.profiles && props.profiles.length > 0 && (
					<ul
						className='w-full grid gap-spacing-lg sm:grid-cols-(--sm-cols) lg:grid-cols-(--lg-cols)'
						style={
							{
								'--sm-cols': `repeat(${smCols}, minmax(0, 1fr))`,
								'--lg-cols': `repeat(${lgCols}, minmax(0, 1fr))`,
							} as CSSProperties
						}
					>
						{props.profiles.map((item, i) => (
							<li key={i}>
								<ProfileCard {...item} />
							</li>
						))}
					</ul>
				)}
			</Container>
		</section>
	);
}
